import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "account-info__items" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "enterprise-real-form-upload" }, " 请上传证件的彩色扫描件或照 片，并确保您上传的图片信息内容清 晰、可辨，单个文件大小不超过 5M； 企业用户需加盖公章 ", -1)

import { ref, watch, onMounted, computed } from 'vue';
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseSelect,
  BaseCascader,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { getCategoryList, getRegionList } from '../../data-source/apis';
import { useUpload } from '../../hooks';
import BizFormTimes from '@/components/biz/biz-form-times';
import { calcIsOverSixMonths } from '../../utils/is-over-six-months';
import appStore from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'account-info-company',
  setup(__props) {

const PRINCIPAL_TYPE = [
  { label: '商业公司', value: 1 },
  { label: '个体工商户', value: 2 }
];
const OPEN_ACCOUNT_TYPE = [
  { label: '开户许可证核准号', value: 1 },
  { label: '基本存款账户编号', value: 2 }
];

const { formData, formRef, payPassagewayCode, disabled } = storeToRefs(
  infoStore()
);
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);
/** 供应商不涉及开通方式相关逻辑 */
const isSupplier = computed(() => userInfo.value.functionCode === 3);
const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, ['companyBusinessLicense']);

const majorCategoryRef = ref(null);
const areaCodeRef = ref(null);
const categoryListOption = ref([]); // 行业分类项
const category = ref([]); // 行业分类值 label
const ssq = ref([]); // 所在省市区 label

const ssqProps = {
  lazy: true,
  lazyLoad: async (node, resolve) => {
    const { level, value } = node as any;
    const { data } = await getRegionList({
      level: level + 1,
      parentCode: value || 0,
      payPassagewayCode: payPassagewayCode.value
    });
    const nodes = data.map(item => {
      return { value: item.code, label: item.name, leaf: level >= 2 };
    });
    resolve(nodes);
  }
};

watch(
  () => formData.value,
  v => {
    // 初始数据
    if (v.majorCategory && v.subCategory && v.businessDesc) {
      category.value = [v.majorCategory, v.subCategory, v.businessDesc];
    }
    if (v.areaCode) {
      ssq.value = [v.provinceCode, v.cityCode, v.areaCode];
    }
  },
  { immediate: true, deep: true }
);

const validateField = field => {
  formRef.value.validateField(field);
};

/**
 * 未开户：营业期限起变更时写入 isOverSixMonths（供应商不涉及）
 * 非未开户：表单禁用不会触发，直接用接口返回的 isOverSixMonths
 */
const onBusinessStartChange = (startAt: string) => {
  if (isSupplier.value) return;
  const status = calcIsOverSixMonths(startAt);
  formData.value.isOverSixMonths = status;
  // 仅开通富友支付：固定中信百信银行
  if (status === 0) {
    formData.value.fyChannel = '01';
  }
};

const onCategoryChange = async () => {
  const [nodes] = majorCategoryRef.value.getCheckedNodes();
  const { pathValues } = nodes;
  formData.value.majorCategory = category.value[0];
  formData.value.subCategory = category.value[1];
  formData.value.businessDesc = category.value[2];
  // FIXME: 修改后使用三级code赋值给mcc
  formData.value.mcc = pathValues[2];
  validateField('majorCategory');
};
const onSsqChange = () => {
  const [nodes] = areaCodeRef.value.getCheckedNodes();
  const { pathLabels, pathValues } = nodes;
  formData.value.provinceCode = pathValues[0];
  formData.value.cityCode = pathValues[1];
  formData.value.areaCode = pathValues[2];
  formData.value.provinceName = pathLabels[0];
  formData.value.cityName = pathLabels[1];
  formData.value.areaName = pathLabels[2];
  validateField('areaCode');
};

onMounted(async () => {
  // FIXME: 该接口第三级lable value是反的，组件使用value展示，change后给mcc赋值对应code
  const { data } = await getCategoryList({
    payPassagewayCode: payPassagewayCode.value
  });
  categoryListOption.value = data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode("公司信息")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), { class: "account-info__content" }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseFormItem), {
          label: "公司名称",
          prop: "companyName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入公司名称",
              disabled: "",
              modelValue: _unref(formData).companyName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).companyName) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "统一社会信用代码",
          prop: "companyCardNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              placeholder: "请输入统一社会信用代码",
              disabled: "",
              modelValue: _unref(formData).companyCardNo,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).companyCardNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "主体类型",
          prop: "companyMainType",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              placeholder: "请选择",
              options: PRINCIPAL_TYPE,
              modelValue: _unref(formData).companyMainType,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).companyMainType) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "公司电话",
          prop: "companyPhone",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              clearable: "",
              modelValue: _unref(formData).companyPhone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).companyPhone) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "证件类型",
          prop: "openAccountType",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请选择'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseSelect), {
              placeholder: "请选择",
              options: OPEN_ACCOUNT_TYPE,
              modelValue: _unref(formData).openAccountType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).openAccountType) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "对应证件码",
          prop: "openAccountCode",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              clearable: "",
              modelValue: _unref(formData).openAccountCode,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).openAccountCode) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "注册地址",
          prop: "companyBusinessAddress",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              style: {"width":"100%"},
              type: "text",
              placeholder: "请输入",
              clearable: "",
              "show-word-limit": "",
              maxlength: 50,
              modelValue: _unref(formData).companyBusinessAddress,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).companyBusinessAddress) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BizFormTimes), {
          class: "account-info__block",
          label: "营业期限",
          startProp: "companyBusinessStartAt",
          endProp: "companyBusinessEndAt",
          start: _unref(formData).companyBusinessStartAt,
          "onUpdate:start": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).companyBusinessStartAt) = $event)),
          end: _unref(formData).companyBusinessEndAt,
          "onUpdate:end": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).companyBusinessEndAt) = $event)),
          onStartChange: onBusinessStartChange
        }, null, 8, ["start", "end"]),
        (['10', '12'].includes(_unref(formData).fyChannel))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(BaseFormItem), {
                label: "行业类别",
                prop: "majorCategory",
                rules: [
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseCascader), {
                    style: {"width":"100%"},
                    ref_key: "majorCategoryRef",
                    ref: majorCategoryRef,
                    key: "majorCategory",
                    placeholder: "请选择",
                    clearable: "",
                    filterable: "",
                    options: categoryListOption.value,
                    props: {
              value: 'label',
              label: 'value'
            },
                    modelValue: category.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((category).value = $event)),
                    onChange: onCategoryChange
                  }, null, 8, ["options", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "注册所属省市区",
                prop: "areaCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseCascader), {
                    style: {"width":"100%"},
                    ref_key: "areaCodeRef",
                    ref: areaCodeRef,
                    key: "areaCode",
                    placeholder: "请选择",
                    clearable: "",
                    filterable: "",
                    props: ssqProps,
                    modelValue: ssq.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ssq).value = $event)),
                    onChange: onSsqChange
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "注册资本",
                prop: "registeredCapital"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "text",
                    placeholder: "请输入",
                    clearable: "",
                    inputTextReplace: "",
                    modelValue: _unref(formData).registeredCapital,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).registeredCapital) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BaseFormItem), {
                label: "经营范围",
                prop: "businessScope",
                rules: [
            {
              required: true,
              trigger: 'change',
              message: '请填写'
            }
          ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BaseInput), {
                    style: {"width":"100%"},
                    type: "text",
                    placeholder: "请输入",
                    clearable: "",
                    "show-word-limit": "",
                    maxlength: 1000,
                    modelValue: _unref(formData).businessScope,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).businessScope) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_unref(BaseFormItem), {
          style: {"grid-column-start":"1","grid-column-end":"3"},
          label: "营业执照",
          prop: "companyBusinessLicense",
          rules: [
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseUpload), {
              style: {"width":"100%"},
              ref: "companyBusinessLicenseRef",
              listType: "picture-card",
              disabled: _unref(disabled),
              accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
              drag: false,
              limit: 1,
              limitSize: 5,
              multiple: false,
              "auto-upload": true,
              onError: _unref(onUploadErr),
              "http-request": _unref(uploadApi),
              beforeRemove: 
            (file, remove) => {
              remove();
              _unref(onUploadRemove)('companyBusinessLicense');
              return true;
            }
          ,
              fileList: _unref(uploadModelMap).companyBusinessLicense,
              "onUpdate:fileList": _cache[13] || (_cache[13] = ($event: any) => ((_unref(uploadModelMap).companyBusinessLicense) = $event)),
              onChange: _cache[14] || (_cache[14] = v => _unref(onUploadChange)(v, 'companyBusinessLicense'))
            }, {
              tip: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled", "onError", "http-request", "beforeRemove", "fileList"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})